import React from 'react';
import { withRouter } from 'react-router-dom';
import { isIE, isSafari, isMobile, isIOS, isChrome } from 'react-device-detect';

import {prepareWidgetData} from '../../../../helpers/itemizationDataHelper';
import {getChartSeries, getCommonChartOptions} from '../../../../helpers/highchartHelper';
import BCLButton from '../../../common/Buttons/BCLButton';
import checklist from '../../../../img/checklist.svg';
import {INSIGHTS_PATH} from '../../../../constants/paths';
import {displayCost, displayUsage, displayPercentage } from '../../../../helpers/helper';
import { Configuration } from "../../../../configs/Configuration";
import {USAGE_TYPE, PIE_CHART_SIZE, FUEL_TYPE, PAGE_EVENT_NAMES, HOME_SURVEY, HOME, HOME_PAGE_WIDGETS} from '../../../../constants/common';
import BCLHighchart from '../../../common/Highchart/BCLHighchart';
import { trackEvent } from '../../../../helpers/analyticsHelper';

class ConsumptionBreakdown extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      seriesData: null,
      slicedSeriesData: null,
      totalCostOrConsumption: null,
      itemizationAvailable : false,
      mode: USAGE_TYPE.COST,
      consumptionBreakdownTranslations : {
        title: this.props.translations.data["CONSUMPTION_BREAKDOWN.TITLE.2"],
        subtitle_LP: this.props.translations.data["CONSUMPTION_BREAKDOWN.SUBTITLE.LAST_PERIOD.2"],
        totalText : this.props.translations.data["COMMON.TOTAL_TEXT"]
      },
      colors: Configuration.getColors(),
      fuelType : FUEL_TYPE.ELECTRIC
    };
    this.configColors = Configuration.getColors().colors;
  }

  componentDidMount(){
    const fuelType = this.props.fuelType;
    const displayValue = this.props.displayValue;
    let widgetData = prepareWidgetData(this.props.itemizationData.itemizationDetails[fuelType], displayValue, this.props.applianceList);
    this.setState({
      seriesData: widgetData.seriesData,
      slicedSeriesData: widgetData.slicedSeriesData,
      totalCostOrConsumption: widgetData.totalCostOrConsumption,
      itemizationAvailable : this.props.itemizationData.itemizationDetails[fuelType] != null,
      mode : displayValue,
      fuelType : fuelType
    });
  }

  afterChartCreated(chart) {
    this.internalChart = chart;
  }

  render(){
    const isMobileChrome = isChrome && isMobile && isIOS;
    const props = this.props;
    const mode = this.state.mode;
    const totalCostOrConsumption = this.state.totalCostOrConsumption;
    const commonChartOptions = getCommonChartOptions(totalCostOrConsumption, mode, true, this.state.consumptionBreakdownTranslations.totalText, null, this.state.fuelType);
    const options = commonChartOptions;
    const self = this;
    const fuelType = this.state.fuelType;
    options.series = getChartSeries(this.state.slicedSeriesData, this.state.seriesData, this.state.slicedSeriesData, PIE_CHART_SIZE.SMALL);
    const seriesDataLength = this.state.seriesData ? this.state.seriesData.length : 4;
    options.responsive = {
      rules: [{
        condition: {
          maxWidth: 400
        },
        chartOptions: {
          chart:{
            animation : false,
            height : 340
          },
          legend: {
            itemStyle: {
              fontSize: '12px'
            },
            width : 'auto',
            align : 'center',
            verticalAlign: "bottom",
            layout : "vertical",
            alignColumns: false
          },
          title: {
            x: 0,
            y: seriesDataLength == 4 ? -80 : -50
          },
          subtitle: {
            x:0,
            y: seriesDataLength == 4 ? -55 : -25
          }
        }
      }]
    };
    options.plotOptions.pie.point.events = {
      legendItemClick: function(e) {
        //Appliance ID for Other Appliances is 99
        if(e.target.options.isRemainingTotal){
          props.resetMonthlySummaryData();
          // reset data is an async action and it may take sometime to propogate to store, so redirect after a timeout
          setTimeout(() => {
            props.history.push(INSIGHTS_PATH.MONTHLY_SUMMARY);
            trackEvent(props.userId, PAGE_EVENT_NAMES.DASHBOARD, {
              btnClicked : HOME_SURVEY,
              widget : HOME_PAGE_WIDGETS.CONSUMPTION_BREAKDOWN
            })
          }, 100);
        }
        e.preventDefault();
      },
      mouseOver : function(e){
        e.preventDefault();
      }
    };
    options.legend = {
      align: 'right',
      width: 180,
      x: -60,
      verticalAlign: 'middle',
      layout: 'vertical',
      padding: 3,
      itemMarginTop:0,
      itemMarginBottom: 20,
      itemStyle: {
          fontSize: '14px',
          color: `rgb(${this.configColors['--color_40']})`,
          lineHeight: '22px'
      },
      labelFormatter: function() {
        //TODO: need to add link for last appliance
        if(this.isRemainingTotal) {
          return `<span style="color:rgb(${self.configColors['--color_1']});text-decoration:underline;">
          ${(mode === USAGE_TYPE.COST ? displayCost({cost:this.y, round: true, showCurrency:true }) :
            (mode === USAGE_TYPE.PERCENTAGE ? displayPercentage({percentageVal :this.percentage, round: true}) : 
            displayUsage({usage:this.y, round: true, showUsageUnit:true, fuelType: fuelType})))} ${this.name} </span>`;
        } else {
          return `<span style="cursor: default;">
          ${(mode === USAGE_TYPE.COST ? displayCost({cost:this.y, round: true, showCurrency:true }) :
            (mode === USAGE_TYPE.PERCENTAGE ? displayPercentage({percentageVal :this.percentage, round: true}) : 
            displayUsage({usage:this.y, round: true, showUsageUnit:true, fuelType: fuelType})))} ${this.name} </span>`;
        }
      }
    };

    return(
      <>
          <svg height="0" width="0">
          <defs>
            <filter id="blurFilter2" y="-20" height="120" x="-20" width="120">
              <feOffset in="SourceGraphic" dx="0" dy="0" result="offOut" />
              <feGaussianBlur in="offOut" stdDeviation="10" result="blur2" />
              <feMerge>
                <feMergeNode in="blur2" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <filter id="filter" y="-20" height="150" x="-20" width="150"> <feOffset in="SourceGraphic" dx="0" dy="0"></feOffset> <feGaussianBlur stdDeviation="10" result="DROP"></feGaussianBlur> <feComposite in="DROP" operator="in" result="SHADOW1"></feComposite> <feComponentTransfer in="SHADOW1" result="SHADOW"> <feFuncA type="table" tableValues="0 1.2"></feFuncA> </feComponentTransfer> <feMerge> <feMergeNode in="SHADOW"></feMergeNode> <feMergeNode in="SourceGraphic"></feMergeNode> </feMerge> </filter>
          </defs>
        </svg>
        <div className="app-breakdown-header-container">
          <span className="consumption-breakdown-title">{this.state.consumptionBreakdownTranslations.title}</span>
          {this.props.itemizationData.itemizationDetails.startDate && this.props.itemizationData.itemizationDetails.endDate ?
           <span className="consumption-breakdown-subtitle"> {this.props.itemizationData.itemizationDetails.startDate.toUpperCase()} - {this.props.itemizationData.itemizationDetails.endDate.toUpperCase()} {this.state.consumptionBreakdownTranslations.subtitle_LP}</span>
          : ''}
        </div>
        <div className={"chart-container " + (!this.state.itemizationAvailable && !this.props.itemizationDataFailed ? "blurred" : "") + (!isIE && !isSafari && !isMobileChrome ? " chart-filter" : "")}>
          {this.state.seriesData !=null ? <BCLHighchart callback={ this.afterChartCreated } options={options}/> : ''}
        </div>
        <div className={"breakdown-info-wrapper " + (!this.state.itemizationAvailable && !this.props.itemizationDataFailed ? "no-data" : "")}>
          <div className="breakdown-info">
            {!this.state.itemizationAvailable && !this.props.itemizationDataFailed && <img src={checklist} alt=""/>}
            <p className="breakdown-info-text">{this.props.itemizationData.itemizationDisclaimer}</p>
          </div>
          <div className="breakdown-info-btn">
            <BCLButton
            btnVariant="outlined"
            btnText="Home Survey"
            disableRipple={true}
            btnBackground={`rgb(${this.configColors['--color_54']})`}
            borderColor= {`rgb(${this.configColors['--color_1']})`}
            textColor={`rgb(${this.configColors['--color_1']})`}
            hoverColor={`rgb(${this.configColors['--color_54']})`}
            btnTextTransform="none"
            btnWidth={!this.state.itemizationAvailable && !this.props.itemizationDataFailed ? "100%" : null}
            onClick={() => this.props.goToSurvey()}/>
          </div>
        </div>
        {this.props.itemizationDataFailed && (
          <div className="home-api-error">{this.props.translations.data["HOME.CONSUMPTION_BREAKDOWN.API_ERROR"]}</div>
        )}
      </>
    );
  }
}

export default withRouter(ConsumptionBreakdown);
